/**
 * Componente de Avatar de Galia animada
 * Usa animaciones CSS multi-capa para darle vida orgánica.
 * Soporta estados: idle, greeting, talking, listening, thinking
 * Walk-in entrance animation on first mount.
 */

import { useEffect, useState } from 'react';
import { useAvatarAnimation } from '../../hooks/useAvatarAnimation';
import { PracticeMode } from '../../types';
import './LottieAvatar.css';

interface LottieAvatarProps {
  className?: string;
  mode?: PracticeMode;
  preview?: boolean;
  avatarId?: string;
}

const STATE_CLASS_MAP: Record<string, string> = {
  greeting: 'galia-greeting',
  talking: 'galia-talking',
  listening: 'galia-listening',
  thinking: 'galia-thinking',
};

export function LottieAvatar({
  className,
  mode,
  preview = false,
  avatarId = 'avatar1'
}: LottieAvatarProps) {
  const { currentState } = useAvatarAnimation();
  const stateClass = STATE_CLASS_MAP[currentState] || 'galia-idle';
  const [entering, setEntering] = useState(!preview);

  useEffect(() => {
    if (!entering) return;
    const timer = setTimeout(() => setEntering(false), 2500);
    return () => clearTimeout(timer);
  }, [entering]);

  return (
    <div
      className={`lottie-avatar-container ${preview ? 'preview' : ''} ${entering ? 'galia-walk-in' : ''} ${className || ''}`}
      aria-label="Galia - avatar"
    >
      {/* Shimmer ring on the glassmorphism border */}
      <div className="galia-shimmer" />

      {/* Ground shadow — animates with Galia's float */}
      <div className={`galia-shadow ${stateClass}-shadow`} />

      {/* Galia herself */}
      <img
        src="/assets/ui/avatares/Galia_.png"
        alt="Galia"
        className={`galia-avatar ${entering ? 'galia-walking' : stateClass}`}
        draggable={false}
      />
    </div>
  );
}

export { useAvatarAnimation };
